import { Crumbs, PageHead, useToast } from '@concord/ui';
import { useQueryClient } from '@tanstack/react-query';
import { useNavigate, useParams } from 'react-router';
import type { Me } from '../../lib/session';
import { ConsoleLayout } from '../console/ConsoleLayout';
import { IntakeWizard } from './IntakeWizard';

/** INT-12: the same intake, completed by a navigator for a patient who called. */
export function StaffIntake({ me }: { me: Me }) {
  const { id = '' } = useParams();
  const navigate = useNavigate();
  const toast = useToast();
  const qc = useQueryClient();
  return (
    <IntakeWizard
      mode="staff"
      base={`/console/intake/${id}`}
      onSent={async (reference) => {
        await qc.invalidateQueries({ queryKey: ['cases'] });
        toast(`Sent as ${reference}. The patient has been emailed.`);
        navigate(`/console/cases/${reference}`);
      }}
      frame={(content, v) => (
        <ConsoleLayout me={me} current="cases">
          <Crumbs items={[{ label: 'Cases', to: '/console/cases' }, { label: 'New case by phone' }]} />
          <PageHead
            title={v ? `New case for ${v.patient.firstName} ${v.patient.lastName}` : 'New case by phone'}
            when="Take the patient through each question. The case records both of you."
          />
          {content}
        </ConsoleLayout>
      )}
    />
  );
}
